<template>
    <div>
        <div class="container-fluid pt-4">
            <b-modal id="StoreAlertEdit" title="Admin" @ok="close()" ok-only>
                <p class="my-4">{{ message }}</p>
            </b-modal>
            <b-modal id="StoreDeleteModal" title="Admin" @ok="deleteRow(id)">
                <p class="my-4">Are you sure you want to delete this slider?</p>
            </b-modal>
            <hr>
            <div class="row product-adding">
                <div class="col-xl-12">
                    <div class="row product-adding">
                        <div class="col-xl-12">
                            <!-- Sous 768 px le tableau passe en mode empilé et son
                                 en-tête (qui contient le bouton d'ajout version bureau)
                                 est masqué : on affiche alors le bouton au-dessus du
                                 tableau, avec son propre modal. -->
                            <div class="d-md-none text-right mb-2">
                                <sliderModalAdd @formData="formData" :host="form.host"
                                    modal-id="modal-SliderAddMobile" />
                            </div>
                            <div class="table-responsive datatable-vue">
                                <b-modal id="modal-2" title="Confirmation" @ok="deleteRow(sliderid)">
                                    <p class="my-4">Are you sure you want to delete this Slider?</p>
                                </b-modal>
                                <b-table ref="tableSlider" sticky-header striped hover responsive class="text-center"
                                    bordered head-variant="light" show-empty stacked="md" :items="form.sliders"
                                    :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage"
                                    @filtered="onFiltered" :select-mode="selectMode" :selectable="true">
                                    <template #cell(image)="field">
                                        <img height="auto" :src="field.item.image" width="100%" />
                                    </template>
                                    <template #row-details="field">
                                        <b-card>
                                            <ul style="text-align:left">
                                                <li>Title : {{ field.item.title }}</li>
                                                <li>Sub title : {{ field.item.subtitle }}</li>
                                                <li>Offer : {{ field.item.offer }}</li>
                                                <li>Link : {{ field.item.link }}</li>
                                                <li>Align : {{ field.item.align }}</li>
                                                <li>Status : {{ field.item.status }}</li>
                                            </ul>
                                        </b-card>
                                    </template>
                                    <template v-slot:cell(actions)="item">
                                        <div class="row-actions">
                                            <button type="button" class="icon-btn" title="View details"
                                                @click="item.toggleDetails">
                                                <feather type="eye" size="16"></feather>
                                            </button>
                                            <sliderModalEdit @formData="formData" :id="item.index" :title="item.item.title"
                                                :subtitle="item.item.subtitle" :image="item.item.image" :offer="item.item.offer"
                                                :link="item.item.link" :status="item.item.status" :align="item.item.align"
                                                :titlecolor="item.item.titlecolor" :subtitlecolor="item.item.subtitlecolor"
                                                :offercolor="item.item.offercolor" :host="form.host" />
                                            <button type="button" class="icon-btn icon-btn-danger" title="Delete slider"
                                                v-b-modal.StoreDeleteModal @click="getIndex(item.index)">
                                                <feather type="trash-2" size="16"></feather>
                                            </button>
                                        </div>
                                    </template>
                                    <template v-slot:head(actions)="item">
                                        <sliderModalAdd @formData="formData" :host="form.host" />
                                    </template>
                                </b-table>
                            </div>
                            <b-col md="12" class="my-1 pagination-justify p-0">
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                                    aria-controls="my-table" class="mt-4"></b-pagination>
                            </b-col>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import { uploadUrl, uploadHeaders } from './../../../utils/imageUpload';
import { VueEditor } from "vue2-editor";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import sliderModalAdd from "./sliderModalAdd.vue";
import sliderModalEdit from "./sliderModalEdit.vue";
import Cookies from 'js-cookie';
export default {
    components: { sliderModalAdd, sliderModalEdit, VueEditor },
    data() {
        return {
            form: {},
            data: {},
            id: '',
            message: "",
            error: 0,
            editor: ClassicEditor,
            tablefields: [
                { key: "image", label: "Image", sortable: false },
                { key: "actions" }
            ],
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],
            sliders: [],
            categories: [],
            slider: "",
            sliderid: "",
            index: null,
            selectMode: "single",
            ImagesEditLogoOptions: {
                url: uploadUrl,
                headers: uploadHeaders(),
                thumbnailWidth: 300,
                thumbnailHeight: 70,
                maxFiles: 1,
                params: null,
                maxfilesexceeded: function (file) {
                    this.removeAllFiles();
                    this.addFile(file);
                },
                accept: function (file, done) {
                    done();
                },
                init: function () {
                    this.removeAllFiles();
                    let image = this.options.params;
                    let f = {
                        size: '12300',
                        name: 'logo',
                        dataURL: image,
                    };
                    this.files.push(f);
                    this.emit("addedfile", f);
                    this.emit("thumbnail", f, f.dataURL);
                    this.emit("complete", f);
                    this.on("removedfile", function (file) {
                        return null;
                    });
                },
                maxFilesize: 100,
                addRemoveLinks: true,
                uploadMultiple: false,
                maxThumbnailFilesize: 20,
                dictDefaultMessage:
                    "<i class='icon-cloud-up'></i><h6>Drop files here or click to upload. 150 x 50 px</h6><</span>",
            },
        };
    },
    computed: {
        sortOptions() {
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key };
                });
        },
        selectedRows() {
            return this.form.sliders.filter(item => item.delete);
        }
    },
    async mounted() {
        var data = await this.getStoresData();
        console.log(data);
        this.form = data[0];
        this.sliders = data[0].sliders;
        this.categories = data[0].categories;
        this.ImagesEditLogoOptions.params = this.form.logo;
    },
    methods: {
        async save(data) {
            if ((this.form.title == "") || (this.form.host == "") || (this.form.logo == "") || (this.form.symbol == "") || (this.form.rate == "")) {
                this.message = "Please complete all required fields!";
                this.error = 1;
                this.$bvModal.show('StoreAlertEdit');
                return false;
            } else {
                this.error = 0;
            }

            // On n'écrit QUE le tableau des sliders : réécrire tout le
            // document écraserait les réglages modifiés entre-temps sur
            // d'autres pages, par exemple la hauteur du carrousel réglée
            // sur la page Thème.
            let ref = await firebase.firestore().collection('Sites').doc(this.form.host).update({ sliders: this.form.sliders })
                .then(() => {
                    this.message = "Document successfully written!";
                    this.error = 0;
                    this.$bvModal.show('StoreAlertEdit');
                })
                .catch((error) => {
                    this.message = "Error writing document: " + error;
                    this.error = 1;
                    this.$bvModal.show('StoreAlertEdit');
                });
        },
        close() {
            if (this.error == 0) this.$bvModal.hide('modal-StoreEdit' + this.id);
        },
        back() {
            this.$bvModal.hide('modal-StoreEdit' + this.id);
        },
        getIndex(id) {
            this.sliderid = id;
        },
        async deleteRow(id) {
            this.form.sliders.splice(id, 1);
            this.save();
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        formData(e) {
            // Sécurité : Firestore refuse d'enregistrer la valeur
            // « undefined » et bloquerait alors tout le tableau — on
            // retire les champs vides avant d'enregistrer.
            Object.keys(e).forEach(function (key) {
                if (e[key] === undefined) delete e[key];
            });
            let find = false;
            this.form.sliders.forEach((element, index, array) => {
                if (index == e.id) {
                    // L'identifiant ne sert qu'à retrouver la ligne : on ne
                    // le stocke pas dans le slider. splice garde le tableau
                    // réactif, la ligne du tableau se met à jour aussitôt.
                    delete e.id;
                    array.splice(index, 1, e);
                    find = true;
                }
            });
            if (find === false) this.form.sliders.push(e);
            this.save();
            this.$refs.tableSlider.refresh();
        },
        updateformData(e) {
            this.sliders[e.id] = e;
            this.$refs.tableSlider.refresh();
        },
        uploadComplete(file) {
            Promise.all([this.get_url(this.dataURItoBlob(file.dataURL), file.name)])
                .then((res) => {
                    this.form.logo = res[0];
                });
        },
        fileRemoved() {

        },
        uploadSuccess() {

        },
        imageResize(base64Str) {
            var img = new Image();
            img.src = base64Str;
            var canvas = document.createElement('canvas');
            var MAX_WIDTH = 300;
            var MAX_HEIGHT = 50;
            var width = img.width;
            var height = img.height;

            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            return canvas.toDataURL();
        },
        showmodal() {
            this.$bvModal.show('modal-StoreEdit' + this.id);
        },
        async getStoresData() {
            let listData = [];
            var ProductRef = await firebase.firestore().collection("Sites")
                .where("host", "==", this.getStore())
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        this.id = doc.id;
                        listData.push(
                            doc.data()
                        );
                    });
                });
            return listData;

        },
        onFileChange(event) {
            let picture = event.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(picture);
            reader.onloadend = (e) => {
                this.form.logo = e.target.result;
            };
        },
        clear() {
            this.form = {};
            this.sliders = [];
        },
        ok(e) {
            this.form.categories = e;
        },
        dataURItoBlob(dataURI) {
          // Extract the base64-encoded data from the Data URI
          var byteString = atob(dataURI.split(',')[1]);

          // Create an ArrayBuffer to hold the binary data
          var buffer = new ArrayBuffer(byteString.length);

          // Create a typed array from the buffer
          var uint8Array = new Uint8Array(buffer);

          // Populate the typed array with the binary data
          for (var i = 0; i < byteString.length; i++) {
              uint8Array[i] = byteString.charCodeAt(i);
          }

          // Create a Blob from the ArrayBuffer, specifying the MIME type as 'image/webp'
          return new Blob([uint8Array], { type: 'image/webp' });
      },
        async get_url(file, filename) {
            // Téléversement vers l'API Hermes (stockage sur le disque du
            // serveur, dossier api/uploads) : remplace Firebase Storage
            // dont le bucket a dépassé le quota du plan gratuit Spark.
            if (!file) {
                return null;
            }
            const safeName = String(filename || 'logo').replace(/[#\[\]*?]/g, '-');
            const ext = file.type === 'image/png' ? '.png' : '.webp';
            const form = new FormData();
            form.append('folder', 'sites/' + this.form.host + '/logo');
            form.append('file', file, safeName + ext);
            const res = await fetch(uploadUrl, { method: 'POST', headers: uploadHeaders(), body: form });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.error || 'Erreur ' + res.status + ' : /api/uploads injoignable (API Hermes démarrée ? proxy /api actif ?)');
            return data.url;
        },
        getStore() {
            const host = Cookies.get('hostCookie');
            if (host) {
                return host;
            } else {
                this.$router.push('/dashboard/default');
            }
        }
    }
};
</script>
<style lang="scss" scoped>
table.text-center * {
    text-align: center;
}
</style>